var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.43 68.26a1 1 0 0 1 -1-1v-15.5a1 1 0 0 1 2 0v13.893c2.767-1.425 8.933-4.922 12.412-9.378a1 1 0 0 1 1.576 1.23c-4.866 6.233-14.182 10.488-14.576 10.666a1.009 1.009 0 0 1 -.412.089z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.289 12.46a.99.99 0 0 1 -.466-.116 28.665 28.665 0 0 0 -2.623-1.217 1 1 0 0 1 .749-1.854 30.347 30.347 0 0 1 2.813 1.3 1 1 0 0 1 -.468 1.884z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.429 52.76a.985.985 0 0 1 -.519-.147c-8.205-5.004-12.91-12.429-12.91-20.373 0-14.407 15.632-26.178 34.847-26.24a1 1 0 0 1 0 2c-18.109.058-32.847 10.932-32.847 24.24 0 7.23 4.356 14.033 11.951 18.666a1 1 0 0 1 -.522 1.854z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.9 9.09a.949.949 0 0 1 -.229-.027c-.9-.209-1.811-.384-2.794-.535a1 1 0 0 1 .3-1.976c1.035.158 2 .343 2.946.564a1 1 0 0 1 -.223 1.974z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37 58.49a46.565 46.565 0 0 1 -7.532-.613 1 1 0 1 1 .324-1.974 44.5 44.5 0 0 0 7.208.587c18.2 0 33-10.878 33-24.25 0-5.9-2.934-11.6-8.26-16.032a1 1 0 1 1 1.28-1.537c5.791 4.821 8.98 11.06 8.98 17.569 0 14.474-15.7 26.25-35 26.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m34.356 42.977a3.676 3.676 0 0 1 -3.668-3.668v-14.128a3.664 3.664 0 0 1 5.881-2.918l9.3 7.064a3.666 3.666 0 0 1 0 5.836l-9.3 7.064a3.652 3.652 0 0 1 -2.213.75zm0-19.466a1.674 1.674 0 0 0 -.747.179 1.634 1.634 0 0 0 -.924 1.491v14.128a1.664 1.664 0 0 0 2.671 1.325l9.3-7.064a1.666 1.666 0 0 0 0-2.651l-9.3-7.063a1.641 1.641 0 0 0 -.997-.345z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.2f91fd2ba099e1a1db2934d145cc2d1a.svg";
export { ForwardRef as ReactComponent };